import { parseInteger } from '../Numbers/parseInteger';

export type EnumObject = { [key: string]: number | string };

export type EnumValue<Enum extends EnumObject> = Enum extends {
  [key: string]: infer Value | string;
}
  ? Value
  : never;

export const Enum = {
  /** using this is probably incorrect. prefer `Enum.values()` */
  keys<EnumType extends EnumObject>(enumObject: EnumType): (keyof EnumType)[] {
    return Object.keys(enumObject).filter(key => Number.isNaN(Number(key)));
  },
  values<EnumType extends EnumObject>(
    enumObject: EnumType,
  ): EnumValue<EnumType>[] {
    return Enum.keys(enumObject).map(
      key => enumObject[key] as EnumValue<EnumType>,
    );
  },
  normalize<EnumType extends EnumObject>(
    enumObject: EnumType,
    value: string | null | undefined,
  ): EnumValue<EnumType> | undefined {
    const values = Enum.values(enumObject);

    if (values[0] === undefined) {
      throw new Error('Enum has to have at least 1 value');
    }

    const parsedValue = (
      typeof value === 'string' && typeof values[0] === 'number'
        ? parseInteger(value)
        : value
    ) as EnumValue<EnumType>;

    if (parsedValue === null || parsedValue === undefined) {
      return undefined;
    }

    return values.includes(parsedValue) ? parsedValue : undefined;
  },
};
